export function getAll() {
  let items = [
    {
      value: 1,
      name: "FoodKindNumber",
      text: "類別編號",
    },
    {
      value: 0,
      name: "FoodKindName",
      text: "類別名稱",
    },
    {
      value: 3,
      name: "FoodNumber",
      text: "商品編號",
    },
    {
      value: 2,
      name: "FoodName",
      text: "商品名稱",
    },
    {
      value: 4,
      name: "Barcode",
      text: "條碼",
    },
    {
      value: 5,
      name: "SupplierNumber",
      text: "廠商編號",
    },
    {
      value: 6,
      name: "SupplierName",
      text: "廠商名稱",
    },
    { value: 8, name: "Summary", text: "簡述" },
  ];
  return items;
}
export function getFood() {
  let items = [
    {
      value: 0,
      name: "FoodNumber",
      text: "商品編號",
    },
    {
      value: 1,
      name: "FoodName",
      text: "商品名稱",
    },
    {
      value: 2,
      name: "Barcode",
      text: "條碼",
    },
    {
      value: 3,
      name: "TaxType",
      text: "稅別",
      isDropDownList: true,
      enumName: "taxType",
    },
    {
      value: 4,
      name: "FoodStockType",
      text: "存貨別",
      isDropDownList: true,
      enumName: "foodStockType",
    },
    {
      value: 5,
      name: "Supplier",
      text: "廠商",
      isModal: true,
    },
  ];
  return items;
}
export function getSupplier() {
  let items = [
    {
      value: 0,
      name: "SupplierNumber",
      text: "廠商編號",
    },
    {
      value: 1,
      name: "SupplierName",
      text: "廠商名稱",
    },
    {
      value: 2,
      name: "UniformNumber",
      text: "統一編號",
    },
    {
      value: 3,
      name: "Phone",
      text: "電話",
    },
  ];
  return items;
}
export function getEmployee() {
  let items = [
    {
      value: 0,
      name: "EmployeeNumber",
      text: "員工編號",
    },
    {
      value: 1,
      name: "EmployeeName",
      text: "員工名稱",
    },
  ];
  return items;
}
export function getCustomer() {
  const hasECPlatform = window.localStorage["hasECPlatform"] == "true";
  let items = [
    {
      value: 0,
      name: "CustomerNumber",
      text: "會員編號",
    },
    {
      value: 1,
      name: "CustomerName",
      text: "會員名稱",
    },
    {
      value: 2,
      name: "Cellphone",
      text: "手機",
    },
    {
      value: 3,
      name: "Phone",
      text: "電話",
    },
    {
      value: 6,
      name: "Birthday",
      text: "生日",
      isBirthday: true,
    },
    // {
    //   value: 4,
    //   name: "Degree",
    //   text: "會員分級",
    //   isDropDownList: true,
    //   enumName: "degreeType",
    // },
  ];
  if (!hasECPlatform) {
    items.push({
      value: 5,
      name: "CreateTime",
      text: "建立時間",
      isDatePicker: true,
    });
  }
  return items;
}
export function getCombination() {
  let items = [
    {
      value: 0,
      name: "FoodKindNumber",
      text: "類別編號",
    },
    {
      value: 1,
      name: "FoodKindName",
      text: "類別名稱",
    },
    {
      value: 2,
      name: "FoodNumber",
      text: "商品編號",
    },
    {
      value: 3,
      name: "FoodName",
      text: "商品名稱",
    },
  ];
  return items;
}
export function getGiftVoucher() {
  let items = [
    {
      value: 0,
      name: "GiftVoucherName",
      text: "優惠券名稱",
    },
    {
      value: 1,
      name: "GiftVoucherNumber",
      text: "優惠券編號",
    },
    {
      value: 2,
      name: "PromotionTypes",
      text: "促銷內容",
      isMultiple: true,
    },
  ];
  return items;
}
export function getGiveRecord() {
  let items = [
    {
      value: 0,
      name: "SendDate",
      text: "發送日期",
      isDatePicker: true,
    },
    {
      value: 1,
      name: "EmployeeNumber",
      text: "員工編號",
    },
    {
      value: 2,
      name: "EmployeeName",
      text: "員工名稱",
    },
  ];
  return items;
}
